import { useEffect } from "react";
import { Outlet } from "react-router";
import CTHeader from "../CTHeader";
import CTSideNav from "../CTSideNav";
import Footer from "../Footer";

type CTLayoutProps = {
  updateTheme: (theme: "light" | "dark") => void;
};

const CTLayout = ({ updateTheme }: CTLayoutProps) => {
  useEffect(() => {
    updateTheme("light");
  }, []);

  return (
    <div className="motif-theme-light">
      <CTHeader />
      <div
        className="motif-no-padding"
        style={{
          backgroundColor: "lightgray",
          display: "flex",
          minHeight: "100vh",
          margin: "0",
          overflow: "hidden",
          padding: "0",
        }}
      >
        <CTSideNav />
        <div
          style={{
            backgroundColor: "var(--body--bg-color)",
            flexGrow: "1",
            padding: "0",
          }}
        >
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CTLayout;
